/* Farmscraft collection page: sort auto-submit and "Show more" loading */
(() => {
  if (window.fccReady) return;
  window.fccReady = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-fcc-autosubmit]');
    if (select && select.form) select.form.submit();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-fcc-more]');
    if (!button || !window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const grid = document.getElementById(button.dataset.fccMore);
    const wrapper = button.closest('.fcc-more');
    const label = button.querySelector('.fcc-more__label');
    const defaultLabel = label ? label.textContent : '';
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Loading…';

    try {
      const response = await fetch(button.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.getElementById(button.dataset.fccMore);
      if (!grid || !nextGrid) throw new Error('grid not found');
      nextGrid.querySelectorAll(':scope > li:not(.fcc-grid__promo)').forEach((item) => grid.appendChild(item));
      // Keep the toolbar's "Showing 1–N" in step with what is on screen.
      const range = document.querySelector('.fcc-toolbar__count strong');
      if (range) range.textContent = `1–${grid.querySelectorAll(':scope > li:not(.fcc-grid__promo)').length}`;

      const nextWrapper = doc.querySelector(`.fcc-more[data-for="${button.dataset.fccMore}"]`);
      const nextButton = nextWrapper && nextWrapper.querySelector('[data-fcc-more]');
      if (nextWrapper && wrapper) {
        wrapper.querySelector('.fcc-more__meta')?.replaceWith(nextWrapper.querySelector('.fcc-more__meta'));
        wrapper.querySelector('.fcc-more__bar')?.replaceWith(nextWrapper.querySelector('.fcc-more__bar'));
      }
      if (nextButton) {
        button.href = nextButton.href;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = defaultLabel;
      } else {
        button.remove();
      }
    } catch (error) {
      window.location.href = button.href; // fall back to a normal page load
    }
  });
})();
